import { BreadcrumbSlot, useBreadcrumb } from "@redotech/arbiter/breadcrumb";
import { Translate, useTranslation } from "@redotech/redo-i18n";
import { memo } from "react";
import { Outlet } from "react-router-dom";

export const TranslatedBreadcrumbLabel = memo(
  function TranslatedBreadcrumbLabel({
    breadcrumb,
    getLabel,
  }: {
    breadcrumb: BreadcrumbSlot;
    getLabel: (t: Translate) => string;
  }) {
    const { t } = useTranslation();
    useBreadcrumb(breadcrumb, getLabel(t));
    return null;
  },
);

export const TranslatedBreadcrumbLayout = memo(
  function TranslatedBreadcrumbLayout({
    breadcrumb,
    getLabel,
  }: {
    breadcrumb: BreadcrumbSlot;
    getLabel: (t: Translate) => string;
  }) {
    return (
      <>
        <TranslatedBreadcrumbLabel
          breadcrumb={breadcrumb}
          getLabel={getLabel}
        />
        <Outlet />
      </>
    );
  },
);

export const ReturnsBreadcrumbLabel = memo(function ReturnsBreadcrumbLabel({
  breadcrumb,
}: {
  breadcrumb: BreadcrumbSlot;
}) {
  const { t } = useTranslation();
  useBreadcrumb(breadcrumb, t("Returns"));
  return null;
});

export const ReturnsListBreadcrumbLayout = memo(
  function ReturnsListBreadcrumbLayout({
    breadcrumb,
  }: {
    breadcrumb: BreadcrumbSlot;
  }) {
    return (
      <>
        <ReturnsBreadcrumbLabel breadcrumb={breadcrumb} />
        <Outlet />
      </>
    );
  },
);
